module.exports = __webpack_public_path__ + "media/images/lb/362-d68ae28da039d5a0acf7b3081a38b90c.svg";